import ios from '../../dist/ionicons/svg/ios-podium.svg';
import md from '../../dist/ionicons/svg/md-podium.svg';

export default /*#__PURE__*/ {
  ios: ios,
  md: md
};